export default (o) => {
    const {
            btnText,
            cid,
            errorClass,
            labelText,
            showHint,
            tootltipText,
            btnTitle,
            inputClass,
            inputID,
            inputName,
            maxLength,
            minLength,
        } = o,
        hintHtml = (text) => `
            <div class="captcha__hint">
                <span class="ifi-sign-question" title="${text}"></span>
            </div>`;

    return `
        <div class="captcha" id="${cid}">
        <div class="captcha__content ii-anim-loading-t1">
            <img alt="captcha" class="captcha__img img-responsive" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==">
            <div class="captcha__toolbar">
                ${showHint ? hintHtml(tootltipText) : ''}
                <button class="captcha__regenerate" id="captcha__regenerate_${cid}" tabindex="-1" title="${btnTitle}" type="button">
                    ${btnText}
                    <span class="ifi-reload"></span>
                </button>
            </div>
        </div>
        <div class="input-group ${errorClass}">
            <span class="input-group-addon input-group-text">${labelText}:</span>
            <input class="captcha__entered" type="hidden">
            <input autocomplete="off" class="form-control ${inputClass}" id="${inputID}" maxlength="${maxLength}" minlength="${minLength}" name="${inputName}" required type="text">
        </div>
    </div>`;
};
